/* Kampagneslider til forsiden */
(function () {
  if (window.__csLoaded) { if (window.__csInitAll) window.__csInitAll(); return; }
  window.__csLoaded = true;

  function init(el) {
    if (!el || el.__csInit) return;
    el.__csInit = true;

    var slides = [].slice.call(el.querySelectorAll('.cs-slide'));
    var dots = [].slice.call(el.querySelectorAll('.cs-dot'));
    var n = slides.length;
    if (n < 2) return;

    var i = 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = document.documentElement.classList.contains('shopify-design-mode');
    var wantsAuto = el.getAttribute('data-autoplay') === 'true' && !reduce && !designMode;
    var userPaused = false;
    var hoverPaused = false;

    if (!wantsAuto) el.classList.remove('cs--auto');

    function restartFill() {
      var f = dots[i] && dots[i].querySelector('.cs-dot__fill');
      if (!f) return;
      f.style.animation = 'none';
      void f.offsetWidth;
      f.style.animation = '';
    }

    function go(k) {
      k = (k + n) % n;
      if (k === i) { restartFill(); return; }
      slides[i].classList.remove('is-active');
      slides[i].setAttribute('aria-hidden', 'true');
      slides[i].setAttribute('inert', '');
      dots[i].classList.remove('is-active');
      dots[i].setAttribute('aria-selected', 'false');
      i = k;
      slides[i].classList.add('is-active');
      slides[i].removeAttribute('aria-hidden');
      slides[i].removeAttribute('inert');
      dots[i].classList.add('is-active');
      dots[i].setAttribute('aria-selected', 'true');
      restartFill();
    }

    function updatePause() {
      var p = userPaused || hoverPaused || document.hidden;
      el.classList.toggle('is-paused', !!p);
    }

    el.addEventListener('animationend', function (e) {
      if (e.animationName === 'cs-fill' && wantsAuto) go(i + 1);
    });

    var prev = el.querySelector('[data-cs-prev]');
    var next = el.querySelector('[data-cs-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); }); });

    var toggle = el.querySelector('[data-cs-toggle]');
    if (toggle) {
      if (!wantsAuto) toggle.hidden = true;
      toggle.addEventListener('click', function () {
        userPaused = !userPaused;
        toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        toggle.setAttribute('aria-label', userPaused ? 'Afspil kampagnerne' : 'Sæt kampagnerne på pause');
        updatePause();
      });
    }

    el.addEventListener('mouseenter', function () { hoverPaused = true; updatePause(); });
    el.addEventListener('mouseleave', function () { hoverPaused = false; updatePause(); });
    el.addEventListener('focusin', function () { hoverPaused = true; updatePause(); });
    el.addEventListener('focusout', function () { hoverPaused = false; updatePause(); });
    document.addEventListener('visibilitychange', updatePause);

    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(i - 1); }
      else if (e.key === 'ArrowRight') { go(i + 1); }
    });

    var sx = 0, sy = 0, tracking = false;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
    }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });

    /* Temaeditoren: hop til den valgte kampagne */
    el.addEventListener('shopify:block:select', function (e) {
      var idx = slides.indexOf(e.target);
      if (idx > -1) go(idx);
    });
  }

  function initAll(root) {
    [].slice.call((root || document).querySelectorAll('[data-cs]')).forEach(init);
  }
  window.__csInitAll = function () { initAll(); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();